import { t } from 'i18next'
import { connectCurrentRefinements } from 'react-instantsearch-dom'

const ClearRefinements = ({ items, refine }: { items: any; refine: any }) => (
  <button
    className="resetBtn"
    onClick={() => refine(items)}
    disabled={!items.length}
    style={{ cursor: 'pointer' }}
  >
    {t('reset')}
  </button>
)

const CustomClearRefinements = connectCurrentRefinements(ClearRefinements)

export default CustomClearRefinements
